/**
 * @module ol/console
 */

/**
 * @typedef {'info'|'warn'|'error'|'none'} Level
 */

/**
 * @type {Object<Level, number>}
 */
var levels = {
  info: 1,
  warn: 2,
  error: 3,
  none: 4
};

/**
 * @type {number}
 */
var level = levels.info;

/**
 * Set the logging level.  By default, the level is set to 'info' and all
 * messages will be logged.  Set to 'warn' to only display warnings and errors.
 * Set to 'error' to only display errors.  Set to 'none' to silence all messages.
 *
 * @param {Level} l The new level.
 */
export function setLevel(l) {
  level = levels[l];
}

/**
 * @param  {...any} args Arguments to log
 */
export function log() {
  var _console;
  if (level > levels.info) {
    return;
  }
  (_console = console).log.apply(_console, arguments); // eslint-disable-line no-console
}

/**
 * @param  {...any} args Arguments to log
 */
export function warn() {
  var _console2;
  if (level > levels.warn) {
    return;
  }
  (_console2 = console).warn.apply(_console2, arguments); // eslint-disable-line no-console
}

/**
 * @param  {...any} args Arguments to log
 */
export function error() {
  var _console3;
  if (level > levels.error) {
    return;
  }
  (_console3 = console).error.apply(_console3, arguments); // eslint-disable-line no-console
}